import React from 'react';

const AppNotification = ({ appointments }) => {
  return (
    <></>
  );
};

export default AppNotification; 